module.exports = __webpack_public_path__ + "img/downarrow.c931e151.svg";